export interface Node {
    toXML(): string;
}
